import { gql } from 'apollo-angular';
import { FullTacticFragment } from '@modules/tactics/shared/graphql/fragments/full-tactic.fragment';

export const ShareTacticDocument = gql/* GraphQL*/ `
  mutation shareTactic($input: TacticShareInputGraphql!) {
    shareTactic(input: $input) {
      ...FullTactic
    }
  }
  ${FullTacticFragment}
`;
